// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Alert-module__alert--2BrPc{border:solid #ddd;border-left:solid #09c;border-radius:5px;border-width:1px 1px 1px 5px;color:#444;font-size:.75rem;padding:.75rem;word-wrap:break-word;position:relative}.Alert-module__alert--2BrPc.Alert-module__warning--34bR2{color:#f80;border-left-color:#f80}.Alert-module__alert--2BrPc.Alert-module__error--3aRvg{color:#c00;border-left-color:#c00}.Alert-module__alert--2BrPc .Alert-module__dismiss--1rdw9{position:absolute;right:.75rem;top:50%;transform:translateY(-50%);color:#999;cursor:pointer}.Alert-module__alert--2BrPc .Alert-module__dismiss--1rdw9:hover{color:#666}", ""]);
// Exports
exports.locals = {
	"alert": "Alert-module__alert--2BrPc",
	"warning": "Alert-module__warning--34bR2",
	"error": "Alert-module__error--3aRvg",
	"dismiss": "Alert-module__dismiss--1rdw9"
};
module.exports = exports;
